<div class="page-wrapper">
  <div class="root-page-content">
    <div class="page-content-inner">
      <header></header>
      <router-outlet></router-outlet>
      <footer></footer>
    </div>
  </div>
</div>
